

















import AbpBase from "@/lib/abpbase";
import { Component, Prop, Watch } from "vue-property-decorator";
import { QueryLiteraturePageList,DeleteLiterature } from "@/api/pdOutPatient/pdMedicalLiterature";
import addMedicalLiterature from "./addMedicalLiterature.vue";
import pdfShow from "./pdfShow.vue";
@Component({
	components: { addMedicalLiterature, pdfShow },
})
export default class MedicalLiterature extends AbpBase {
  @Prop() patient: any;
  loading: boolean = false;
  tableData: any = [];
  tableTotalSize: number = 0;
  queryCondition: any = {
    Page: 1,
    PageSize: 10,
    queryString: "",
  };
  columns = [
    {
      key: "literatureName",
      title: "文献名称",
      width: 300
    },
    {
      key: "literatureNote",
      title: "文献说明"
    },
    {
			title: "操作",
			width: 220,
			render: (h1: any, p: any) => {
				const h = this.$createElement;
					return h("div", [
						h(
							"Button",
							{
								props: {
									size: "small",
									type: "primary"
								},
								on: {
									click: () => {
										this.editLiterature(p.row);
									},
								},
							},
							"编辑"
						),
						h(
							"Button",
							{
								props: {
									type: "error",
									size: "small"
								},
								style: {
									marginLeft: "15px",
								},
								on: {
									click: () => {
										this.delLiterature(p.row);
									},
								},
							},
							"删除"
						),
						h(
							"Button",
							{
								props: {
									type: "primary",
									size: "small"
								},
								style: {
									marginLeft: "15px",
								},
								on: {
									click: () => {
										this.showImage(p.row);
									},
								},
							},
							"查看"
						),
					]);
			},
		},
  ];

	created() {
     this.getData();
  }

  pageChange(val: any) {
    this.queryCondition.Page = val;
    this.getData();
  }

  async getData() {
    this.loading = true;
    let res = await QueryLiteraturePageList(this.queryCondition);
    this.loading = false;
    this.tableData = res.items;
    this.tableTotalSize = res.totalCount;
  }
  addLiteratureShow = false;
	literatureData: any = {};
  addLiterature() {
		this.literatureData = {
			saveType: "新增",
			reportTime: new Date(),
		}
		this.addLiteratureShow = true;
  }
  editLiterature(literatureData: any) {
		this.literatureData = literatureData;
		this.literatureData.saveType = "编辑";
		this.addLiteratureShow = true;
	}
	delLiterature(literatureData: any) {
		this.$Modal.confirm({
			title: "提示",
			content: "此操作将永久删除该记录, 是否继续?",
			onOk: async () => {
				let res = await DeleteLiterature({ Id: literatureData.id });
				this.getData();
			},
		});
	}
	showPdf = false;
	PdfData = {}
	showImage(PdfData: any) {
		this.PdfData = PdfData;
		this.showPdf = true;
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/pdOutPatient/pdMedicalLiterature/index.vue